export default function _isFunction(x) {
  var type = Object.prototype.toString.call(x);
  return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isFunction.js
// module id = 172
// module chunks = 1